import { useSessionStore } from '@/src/hooks/use_session_store'
import { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import { BaseButton, type BaseButtonProps } from './BaseButton'

//TO DO: Rename component to a more generic name, because is used for more than just saving
export const SaveButton = forwardRef<HTMLButtonElement, Partial<BaseButtonProps>>((props, ref) => {
  const { user } = useSessionStore()
  const { t } = useTranslation()
  return (
    <BaseButton
      variant='primary'
      text={props.text ?? (props.children ? undefined : t('common.save'))}
      ref={ref}
      {...props}
      tooltip={user?.readonly ? t('readonly_action_disabled') : props.tooltip}
      tooltipPlacement={props.tooltipPlacement}
      isDisabled={user?.readonly || props.isDisabled}
    />
  )
})
